<template>
    <div class="tabcontent">
        <v-row justify="space-between">
            <v-col cols="12" md="8" sm="12">
                <v-form ref="form" v-model="valid">
                    <v-row :dense="true">
                      <v-col cols="12" md="4">
                        <v-subheader>Счет к оплате</v-subheader>
                      </v-col>
                      <v-col cols="12" md="8">
                        <v-file-input
                            v-model="filescore"
                            :dense="true"
                            :rules="fileRules"
                            :show-size="true"
                        ></v-file-input>
                        <a v-show="filescorelink != null" :href="filescorelink" target="_blank">{{ filescoreexist }}</a>
                        <v-icon v-show="filescorelink != null" color="red" @click="delFile('filescore')">mdi-close</v-icon>
                      </v-col>
                    </v-row>
                    <v-row :dense="true">
                        <v-col cols="12" md="4">
                            <v-subheader>Получатель</v-subheader>
                        </v-col>
                        <v-col cols="12" md="8">
                            <v-skeleton-loader
                                    :loading="loading"
                                    type="list-item"
                                    class="mx-auto"
                            >
                                <v-combobox
                                        v-model="IdReceiver"
                                        :items="kontragentlist"
                                        :dense="true"
                                        @input="changeReceiver"
                                        required
                                ></v-combobox>
                            </v-skeleton-loader>
                        </v-col>
                    </v-row>

                    <v-row :dense="true">
                        <v-col cols="12" md="4">
                            <v-subheader>Плательщик</v-subheader>
                        </v-col>
                        <v-col cols="12" md="8">
                            <v-skeleton-loader
                                    :loading="loading"
                                    type="list-item"
                                    class="mx-auto"

                            >
                                <v-combobox
                                        v-model="IdOrg"
                                        :items="orglist"
                                        @input="changeOrg"
                                        :dense="true"
                                        :rules="orgRules"
                                        required
                                ></v-combobox>
                            </v-skeleton-loader>
                        </v-col>
                    </v-row>

                    <v-row :dense="true" v-show="IdOrg.value == 16">
                        <v-col cols="12" md="4">
                            <v-subheader>Клиент</v-subheader>
                        </v-col>
                        <v-col cols="12" md="8">
                            <v-skeleton-loader
                                    :loading="loading"
                                    type="list-item"
                                    class="mx-auto"
                            >
                                <v-combobox
                                        @input="changeOrgClient"
                                        v-model="IdClient"
                                        :items="orgClientlist"
                                        :dense="true"
                                        required
                                ></v-combobox>
                            </v-skeleton-loader>
                        </v-col>
                    </v-row>

                    <v-row :dense="true">
                        <v-col cols="12" md="4">
                            <v-subheader>Плановая дата платежа</v-subheader>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-menu
                                    ref="menu1"
                                    v-model="menu1"
                                    @input="changePlanDate"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    offset-y
                                    max-width="290px"
                                    min-width="290px"
                            >
                                <template #activator="{ on, attrs }">
                                    <v-text-field
                                            v-model="PlanDate"
                                            hint="ДД.ММ.ГГГГ"
                                            persistent-hint
                                            v-bind="attrs"
                                            @blur="date = parseDate(PlanDate)"
                                            v-on="on"
                                            @input="changePlanDate"
                                            :dense="true"
                                    ></v-text-field>
                                </template>
                                <v-date-picker v-model="date" first-day-of-week="1" no-title @change="changeDate" @input="menu1 = false" required></v-date-picker>
                            </v-menu>
                        </v-col>
                    </v-row>
                    <v-row :dense="true">
                        <v-col cols="12" md="4">
                            <v-subheader>
                                Объекты
                            </v-subheader>
                        </v-col>
                        <v-col cols="12" md="8">
                            <v-row :dense="true">
                              <v-col md="12">
                                <v-btn
                                    color="primary"
                                    dark
                                    v-bind="attrs"
                                    v-on="on"
                                    :dense="true"
                                    @click="addHousesVal"
                                >
                                  Добавить все объекты
                                </v-btn>
                                <v-btn
                                    color="primary ml-4"
                                    dark
                                    v-bind="attrs"
                                    v-on="on"
                                    :dense="true"
                                    @click="removeHousesVal"
                                >
                                  Удалить все объекты
                                </v-btn>
                              </v-col>
                              <v-col md="12">
                                <v-autocomplete
                                    v-model="housesVal"
                                    :items="objectList"
                                    deletable-chips
                                    dense
                                    chips
                                    label="Объекты"
                                    multiple
                                ></v-autocomplete>
                              </v-col>
                              <v-col md="10">
                                <v-autocomplete
                                    v-model="staiiVal"
                                    :items="staiiAllList"
                                    dense
                                    label="Статья расходов"
                                ></v-autocomplete>
                              </v-col>
                              <v-col md="2">
                                <v-btn
                                    color="primary ml-4"
                                    dark
                                    dense
                                    @click="addAllObject"
                                >
                                  <v-icon>mdi-plus</v-icon>
                                </v-btn>
                              </v-col>
                              <v-col cols="12" v-show="houses.length > 0">
                                <p>Введите сумму для распределения по объектам</p>
                              </v-col>
                              <v-col cols="12" v-show="houses.length > 0">
                                <v-text-field
                                    v-model="SummAllDist"
                                    :counter="10"
                                    label="Сумма"
                                >

                                </v-text-field>
                              </v-col>
                              <v-col cols="12" v-show="houses.length > 0">
                                <v-btn
                                    color="primary"
                                    dark
                                    dense
                                    @click="SummAllDistSquare"
                                >
                                  По площади
                                </v-btn>
                                <v-btn
                                    color="primary ml-4"
                                    dark
                                    :dense="true"
                                    @click="SummAllDistNumb"
                                >
                                  По количеству
                                </v-btn>
                              </v-col>

                                <!--<v-col md="2">
                                    <v-menu offset-y :disabled="!houseslist || houseslist.length <= 0" >
                                        <template #activator="{ on, attrs }">
                                            <v-btn
                                                    color="primary"
                                                    dark
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    :dense="true"
                                                    @click="addHouse"
                                            >
                                                <v-icon>mdi-plus</v-icon>
                                            </v-btn>
                                        </template>
                                        <v-list>
                                            <v-list-item
                                                    v-for="(item, index) in houseslist"
                                                    :key="index"
                                                    @click="addObject(item.ID, item.Name)"
                                            >
                                                <v-list-item-title>{{ item.Name }}</v-list-item-title>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </v-col>-->
                            </v-row>
                            <!--<template v-for="(house, index) in houses">
                                <v-row :key="house.ID" :dense="true">
                                    <v-col md="5">
                                        <v-subheader class="house_name">
                                          {{ house.Name }}
                                        </v-subheader>
                                      <v-icon color="red" @click="delObject(house.ID)">mdi-close</v-icon>
                                    </v-col>
                                    <v-col md="7">
                                      <template v-for="(houseStatii, i) in house.Statii">

                                        <v-row :key="houseStatii.ID+i" class="staiilist_item">
                                            <v-icon color="red" @click="delObjectStatii(index, i)">mdi-close</v-icon>
                                            <v-text-field
                                                v-model="houseStatii.Summ"
                                                :counter="10"
                                                :rules="summaRulesHouse(house.ID)"
                                                label="Сумма к оплате"
                                                @change="syncSums"
                                                required
                                            >

                                            </v-text-field>
                                        <div v-show="UseSumLimitHouse(house.ID)">Лимит: {{limitsumhouse(house.ID) | toCurrency}}</div>
                                        <v-skeleton-loader
                                            :loading="loading"
                                            type="list-item"
                                            class="mx-auto"
                                        >
                                          <v-combobox
                                              v-bind:houseid="house.ID"
                                              v-model="houseStatii.IdStatii"
                                              :items="staiilist"
                                              :dense="true"
                                              label="Статья расходов"
                                              @input="changeStatii(houseStatii, index, i)"
                                              class="zayavki_add_staiilist"
                                              required
                                          ></v-combobox>
                                            <v-text-field
                                                v-model="houseStatii.percentProfit"
                                                label="Процент рентабельности"
                                                :rules="[numberRule]"
                                                required
                                            >
                                            </v-text-field>
                                            <v-text-field

                                                    v-model="houseStatii.Volume"
                                                    label="Введите объём"
                                                    v-show="isVolume(houseStatii.IdStatii)"
                                                    @input="changeVolume"
                                                    required
                                            >
                                            </v-text-field>
                                        </v-skeleton-loader>
                                        </v-row>
                                      </template>
                                      <v-btn
                                          color="primary"
                                          dark
                                          :dense="true"
                                          class="btnHouseStatii"
                                          @click="addHouseIdStatii(house.ID, house.Name, index)"
                                      >
                                        <v-icon>mdi-plus</v-icon>
                                      </v-btn>
                                    </v-col>
                                </v-row>
                            </template>-->
                        </v-col>
                    </v-row>
                    <v-row v-show="houses.length > 0">
                      <v-col cols="12">
                        <v-simple-table>
                          <thead>
                          <tr>
                            <th>
                              Объект
                            </th>
                            <th>
                              Статья
                            </th>
                            <th>
                              Объем
                            </th>
                            <!--<th>
                              Процент рентабельности
                            </th>-->
                            <th>
                              Сумма
                            </th>
                            <th>
                              План/Факт
                            </th>
                            <th>
                            </th>
                          </tr>
                          </thead>
                          <tbody>
                            <template v-for="(house, index) in houses">
                              <tr :key="'tr'+index+house.ID">
                                <td>
                                  {{ house.Name }}
                                </td>
                                <td>
                                  <v-autocomplete
                                      v-model="house.Statii[0].IdStatii"
                                      :items="staiiAllList"
                                      dense
                                      required
                                      @input="housesUnique"
                                  ></v-autocomplete>
                                </td>
                                <td>
                                  <v-text-field
                                      v-model="house.Statii[0].Volume"
                                      v-show="house.Statii[0].isVolume>0"
                                      @input="changeVolume"
                                      required
                                  >
                                  </v-text-field>
                                </td>
                                <!--<td>
                                  <v-text-field
                                      v-model="house.Statii[0].percentProfit"
                                      :rules="[numberRule]"
                                      @input="changeVolume"
                                      required
                                  >
                                  </v-text-field>
                                </td>-->
                                <td>
                                  <v-text-field
                                      v-model="house.Statii[0].Summ"
                                      :counter="10"
                                      :rules="summaRulesHouse(house.ID)"
                                      @change="syncSums"
                                      required
                                  >
                                  </v-text-field>
                                </td>
                                <td>
                                  <span v-show="house.Statii[0].SummPlan!='' && house.Statii[0].IdStatii>0">
                                    {{summaPlan(house.Statii[0])}}
                                  </span>
                                </td>
                                <td>
                                  <v-icon color="red" @click="delObjectIndex(index)">mdi-close</v-icon>
                                </td>
                              </tr>
                            </template>
                          </tbody>
                        </v-simple-table>
                      </v-col>
                    </v-row>
                    <v-row :dense="true" v-show="houses.length <= 0">
                        <v-col cols="12" md="4">
                            <v-subheader>Статья расходов</v-subheader>
                        </v-col>
                        <v-col cols="12" md="8">
                            <v-skeleton-loader
                                    :loading="loading"
                                    type="list-item"
                                    class="mx-auto"
                            >
                                <v-combobox
                                        v-model="IdStatii"
                                        :items="staiilist"
                                        :dense="true"
                                        label="Статья расходов"
                                        @input="changeStatii(IdStatii)"
                                        required
                                ></v-combobox>
                            </v-skeleton-loader>
                        </v-col>
                    </v-row>
                    <!--<v-row :dense="true" v-show="houses.length <= 0">
                      <v-col cols="12" md="4">
                        <v-subheader>Процент рентабельности</v-subheader>
                      </v-col>
                      <v-col cols="12" md="8">
                        <v-text-field
                            v-model="percent"
                            :rules="[numberRule]"
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>-->
                    <v-row :dense="true" v-show="houses.length <= 0">
                        <v-col cols="12" md="4">
                            <v-subheader>Итого к оплатe</v-subheader>
                        </v-col>
                        <v-col cols="12" xs="12" md="4">
                            <v-text-field
                                    v-model="SummaNoObject"
                                    :counter="10"
                                    @input="changeSummaNoObject"
                                    :dense="true"
                            ></v-text-field>
                            <div v-show="UseSummLimit">Лимит: {{limitsum | toCurrency}}</div>
                        </v-col>
                    </v-row>
                    <v-row :dense="true" v-show="houses.length > 0">
                        <v-col cols="12" md="4">
                            <v-subheader>Итого к оплате</v-subheader>
                        </v-col>
                        <v-col cols="12" xs="12" md="4">
                            <v-text-field
                                    v-model="Summa"
                                    :counter="10"
                                    :rules="summaRules"
                                    @input="changeSumma"
                                    :dense="true"
                            ></v-text-field>
                            <div v-show="UseSummLimit">Лимит: {{limitsum | toCurrency}}</div>
                        </v-col>
                    </v-row>
                    <!--
                    <v-row :dense="true" v-if="houses.length == 0">
                        <v-col cols="12" md="4">
                            <v-subheader>Статья расходов</v-subheader>
                        </v-col>
                        <v-col cols="12" md="8">
                            <v-skeleton-loader
                                    :loading="loading"
                                    type="list-item"
                                    class="mx-auto"
                            >
                                <v-combobox
                                        v-model="IdStatii"
                                        :items="staiilist"
                                        :dense="true"
                                        @input="changeStatii"
                                        class="zayavki_add_staiilist"
                                        required
                                ></v-combobox>
                            </v-skeleton-loader>
                        </v-col>
                    </v-row>
                    -->
                    <v-row :dense="true">
                        <v-col cols="12" md="4">
                            <v-subheader>Наименование работ, услуг</v-subheader>
                        </v-col>
                        <v-col cols="12" md="8">
                            <v-textarea
                                    v-model="Osnovanie"
                                    counter="255"
                                    rows="2"
                                    @input="changeOsnovanie"
                                    :dense="true"
                                    required
                            ></v-textarea>
                        </v-col>
                    </v-row>
                    <v-row :dense="true" v-if="idtsg==''">
                        <v-col cols="12" md="4">
                            <v-subheader>Тип операции</v-subheader>
                        </v-col>
                        <v-col cols="12" md="8">
                            <v-skeleton-loader
                                    :loading="loading"
                                    type="list-item"
                                    class="mx-auto"
                            >
                                <v-combobox
                                        v-model="TypeOrder"
                                        :items="TypeOrderList"
                                        :dense="true"
                                        @input="changeTypeOrder"
                                        required
                                ></v-combobox>
                            </v-skeleton-loader>
                        </v-col>
                    </v-row>
                    <v-row :dense="true">
                        <v-col cols="12" md="4">
                            <v-subheader>Закрывающий документ (до 1 МБ)</v-subheader>
                        </v-col>
                        <v-col cols="12" md="8">
                            <v-file-input
                                    v-model="file"
                                    :dense="true"
                                    :rules="fileRules"
                                    :show-size="true"
                            ></v-file-input>
                            <a v-show="filelink != null" :href="filelink" target="_blank">{{ fileexist }}</a>
                            <v-icon v-show="filelink != null" color="red" @click="delFile('file')">mdi-close</v-icon>
                        </v-col>
                    </v-row>

                    <v-row :dense="true">
                        <v-col cols="12" md="4">
                            <v-subheader>Статус</v-subheader>
                        </v-col>
                        <v-col cols="12" xs="12" md="8">
                            <v-skeleton-loader
                                    :loading="loading"
                                    type="list-item"
                                    class="mx-auto"
                            >
                                <v-chip
                                        class="ma-2"
                                        color="secondary"
                                >
                                    {{ statelist[StateZayv] }}

                                </v-chip>
                              <a v-show="StateZayv == 3" @click="ppFile">
                                Скачать платёжное поручение
                              </a>

                               <p v-show="StateZayv == 2">
                                 Причина отмены: {{ CommentRefuse }}
                               </p>

                                <v-btn color="success" class="mr-4" @click="saveStatus(1)" v-show="NeedSoglasovan && id > 0 && StateZayv == 0">
                                    Утвердить
                                </v-btn>
                              <v-dialog
                                  v-model="dialog"
                                  persistent
                                  max-width="500px"
                                  v-show="id > 0 && StateZayv == 0"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                      color="error mr-4"
                                      dark
                                      v-bind="attrs"
                                      v-on="on"
                                      v-show="NeedSoglasovan && id > 0 && StateZayv == 0"
                                  >
                                    Отказать
                                  </v-btn>
                                </template>
                                <v-card>
                                  <v-icon class="float-right RefuseClose" @click="dialog = false">mdi-close</v-icon>
                                  <v-card-title class="headline lighten-2">
                                    Причина отказа
                                  </v-card-title>

                                  <v-card-text>
                                    <v-textarea
                                        solo
                                        name="CommentRefuse"
                                        value=""
                                        v-model="CommentRefuse"
                                        required
                                    ></v-textarea>
                                  </v-card-text>
                                  <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="error" class="mr-4" @click="saveStatus(2); dialog = false" v-show="!NeedSoglasovan && id > 0 && StateZayv == 0">
                                      Отказать
                                    </v-btn>
                                  </v-card-actions>

                                </v-card>
                              </v-dialog>

                                <v-btn color="success" class="mr-4" @click="saveStatus(3)" v-show="!NeedSoglasovan && id > 0 && StateZayv == 0">
                                    Выполнить
                                </v-btn>
                                <v-btn color="success" class="mr-4" @click="saveStatus(3)" v-show="NeedSoglasovan && id > 0 && StateZayv == 1">
                                    Выполнить
                                </v-btn>
                              <v-dialog
                                  v-model="dialog"
                                  persistent
                                  max-width="500px"
                                  v-show="!NeedSoglasovan && id > 0 && StateZayv == 0"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                      color="error mr-4"
                                      dark
                                      v-bind="attrs"
                                      v-on="on"
                                      v-show="!NeedSoglasovan && id > 0 && StateZayv == 0"
                                  >
                                    Отказать
                                  </v-btn>
                                </template>
                                <v-card>
                                  <v-icon class="float-right RefuseClose" @click="dialog = false">mdi-close</v-icon>
                                  <v-card-title class="headline lighten-2">
                                    Причина отказа
                                  </v-card-title>

                                  <v-card-text>
                                    <v-textarea
                                        solo
                                        name="CommentRefuse"
                                        value=""
                                        v-model="CommentRefuse"
                                        required
                                    ></v-textarea>
                                  </v-card-text>
                                  <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="error" class="mr-4" @click="saveStatus(2); dialog = false" v-show="!NeedSoglasovan && id > 0 && StateZayv == 0">
                                      Отказать
                                    </v-btn>
                                  </v-card-actions>

                                </v-card>
                              </v-dialog>

                                <v-btn color="error" class="mr-4" @click="saveStatus(4)" v-show="NeedSoglasovan && id > 0 && StateZayv == 1">
                                    Отменить
                                </v-btn>
                            </v-skeleton-loader>
                        </v-col>
                    </v-row>
                    <input type="hidden" v-model="id">
                    <v-row :dense="true">
                        <v-col cols="12" md="4"></v-col>
                        <v-col cols="12" md="8">
                            <v-btn color="primary" class="mr-4" @click="saveZayavka"
                                   :disabled="!(StateZayv == 0 || StateZayv == 1) || !summaValid()"
                            >
                                Сохранить
                            </v-btn>
                          <v-btn color="primary" v-show="id > 0" class="mr-4" @click="copyZayavka">
                            Скопировать
                          </v-btn>
                        </v-col>
                    </v-row>
                </v-form>
            </v-col>
        </v-row>
        <v-snackbar
                v-model="snackbarresult"
                :timeout="resulttimeout"
        >
            {{ resulttext }}
        </v-snackbar>
      <v-dialog v-model="addHouseDialog" max-width="320">
        <v-card>
          <v-card-title class="headline">Выберите плательщика</v-card-title>
          <v-card-text>

          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="gray darken-1" text @click="addHouseDialog = false">
              OK
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
</template>

<script>

    import { bus } from '../../plugins/bus.js'

    export default {
        name: "ZayavkiAdd",
        props: ['id', 'IdOrgDef', 'newZayav'],
        data() {
            return {
                loading: true,
                IdOrg: '',
                TypeOrder: '',
                IdClient: '',
                valid: true,
                IdZayavitel: 0,
                IdStatii: null,
                IdStatiiObj: [],
                Summa: 0.00,
                SummaNoObject: 0.00,
                PlanDate: '',
                IdReceiver: '',
                Osnovanie: '',
                file: null,
                filescore: null,
                fileexist: '',
                filelink: null,
                fileDelete: false,
                filescoreexist: '',
                filescorelink: null,
                filescoreDelete: false,
                date: '',
                menu1: false,
                houses: [],
                StateZayv: 0,
                statelist: ['Новый', 'Утверждено', 'Отказано', 'Исполнено', 'Отменено'],
                TypeOrderList: ['Оплата контрагентам', 'Оплата услуг сервиса', 'Судебные расходы', 'Перечисление на счет клиента'],
                snackbarresult: false,
                resulttimeout: 2000,
                resulttext: '',
                addHouseDialog: false,
                dialog:null,
                CommentRefuse:'',
                attrs:null,
                on:null,
                localnewZayav: {},
                percent:0,
                housesVal: [],
                staiiVal: '',
                SummAllDist: '',
                idtsg: localStorage.getItem('idtsg'),
            }
        },
        mounted() {
            this.IdZayavitel = localStorage.getItem('user-id');
            this.loadData();
            bus.$on('refreshTabZayavkiAdd'+this.$props.id, this.refreshHandler);
        },
        computed: {
            computedDateFormatted () {
                return this.formatDate(this.date);
            },
            limitsum() {
                let Summ = 0;
                if (this.IdStatii) {

                    if (this.IdStatii.houses) {
                        for (let h of this.IdStatii.houses) {
                            let exits = false;
                            for (let hs of this.houses) {
                                if (hs.ID == h.IdHouse) {
                                    exits = true;
                                    break;
                                }
                            }
                            if (exits) {
                                if (h.Summ) {
                                    Summ += parseFloat(h.Summ);
                                }
                                if (!this.id && h.SummUsed) {
                                    Summ -= parseFloat(h.SummUsed);
                                }
                            }
                        }
                    } else if (this.IdStatii.all) {
                        if (this.IdStatii.all.Summ) {
                            Summ = parseFloat(this.IdStatii.all.Summ);
                        }
                        if (!this.id && this.IdStatii.all.SummUsed) {
                            Summ -= parseFloat(this.IdStatii.all.SummUsed);
                        }
                    }
                }
                return Summ;
            },
            NeedSoglasovan() {
                let ret = false;
                if (this.IdStatii) {
                    if (this.IdStatii.houses) {
                        for (let h of this.IdStatii.houses) {
                            if (h.NeedSoglasovan==1) {
                                ret = true;
                                break;
                            }
                        }
                    } else if (this.IdStatii.all) {
                        ret = this.IdStatii.all.NeedSoglasovan;
                    }
                }
                return ret;
            },
            UseSummLimit() {
                let ret = false;
                if (this.IdStatii) {
                    if (this.IdStatii.houses) {
                        for (let h of this.IdStatii.houses) {
                            if (h.UseLimit == 1) {
                                ret = true;
                                break;
                            }
                        }
                    } else if (this.IdStatii.all && this.IdStatii.all.UseLimit == 1) {
                        ret = true;
                    }
                }
                return ret;
            },
            staiilist() {
                let ret = [];
               // let keyitemst, keyitemsub = 0;
                let staiilist = this.$store.getters.ZAYAVKIFILTERS ? this.$store.getters.ZAYAVKIFILTERS.staiilist : null;
                if (staiilist) {
                    // eslint-disable-next-line no-unused-vars
                    Object.entries(staiilist).forEach(([key, item]) => {

                      let NumbOne = '';
                      if(item.Numb>0)
                        NumbOne = item.Numb;
                      if (item.Name) {
                         ret.push({header: NumbOne +' '+item.Name});
                      }
                      //keyitemst = 0;
                      item.sub.forEach((itemst) => {
                            if (itemst.All || this.houseAllow(itemst)) {

                               // keyitemst++;
                               // keyitemsub = 0;
                                let NumbTwo = '';
                                if(itemst.Numb>0)
                                  NumbTwo = NumbOne+'.'+itemst.Numb;
                                if(itemst.sub.length > 0){
                                  ret.push({header: NumbTwo+' '+itemst.Name, houses: itemst.Houses, all: itemst.All, isVolume: itemst.isVolume, percentProfit: itemst.percentProfit,});
                                }else{
                                  ret.push({text: NumbTwo+' '+itemst.Name, value: itemst.ID, houses: itemst.Houses, all: itemst.All, isVolume: itemst.isVolume, percentProfit: itemst.percentProfit,});
                                }
                                itemst.sub.forEach((itemsub) => {
                                    if (itemst.All || this.houseAllow(itemsub)) {
                                      let NumbThree = '';
                                      if(itemst.Numb>0)
                                        NumbThree = NumbTwo+'.'+itemsub.Numb;
                                      //keyitemsub++
                                        ret.push({
                                            text: NumbThree+' '+itemsub.Name,
                                            value: itemsub.ID,
                                            isVolume: itemsub.isVolume,
                                            houses: itemsub.Houses,
                                            percentProfit: itemsub.percentProfit,
                                            all: itemst.All
                                        });
                                    }
                                });
                            }
                        });
                    });
                }

                return ret;
            },
            staiiAllList() {
              let ret = [];
              let staiilist = this.$store.getters.ZAYAVKIFILTERS ? this.$store.getters.ZAYAVKIFILTERS.staiilist : null;
              if (staiilist) {
                staiilist.forEach((item) => {
                  let NumbOne = '';
                  if(item.Numb>0)
                    NumbOne = item.Numb;
                  if (item.Name) {
                    ret.push({header: NumbOne +' '+item.Name});
                  }
                  item.sub.forEach((itemst) => {
                      let NumbTwo = '';
                      if(itemst.Numb>0)
                        NumbTwo = NumbOne+'.'+itemst.Numb;
                      if(itemst.sub.length > 0){
                        ret.push({header: NumbTwo+' '+itemst.Name, houses: itemst.Houses, all: itemst.All, isVolume: itemst.isVolume, percentProfit: itemst.percentProfit,});
                      }else{
                        ret.push({text: NumbTwo+' '+itemst.Name, value: itemst.ID, houses: itemst.Houses, all: itemst.All, isVolume: itemst.isVolume, percentProfit: itemst.percentProfit,});
                      }
                      itemst.sub.forEach((itemsub) => {
                          let NumbThree = '';
                          if(itemst.Numb>0)
                            NumbThree = NumbTwo+'.'+itemsub.Numb;
                          ret.push({
                            text: NumbThree+' '+itemsub.Name,
                            value: itemsub.ID,
                            isVolume: itemsub.isVolume,
                            houses: itemsub.Houses,
                            percentProfit: itemsub.percentProfit,
                            all: itemst.All
                          });
                      });

                  });
                });
              }

              return ret;
            },
            kontragentlist() {
                let ret = [];
                let kontragents = this.$store.getters.ZAYAVKIFILTERS ? this.$store.getters.ZAYAVKIFILTERS.kontragents : null;
                if (kontragents) {
                  if(localStorage.getItem('idtsg')>0){
                    kontragents.forEach((item) => {
                      if(item.IdTsj == localStorage.getItem('idtsg'))
                        ret.push({text: item.Name + ' (' + item.InnPost + ')', value: item.ID});
                    });
                  }else{
                    kontragents.forEach((item) => {
                        ret.push({text: item.Name + ' (' + item.InnPost + ')', value: item.ID});
                    });
                  }
                }
                return ret;
            },
            orgClientlist() {
                let ret = [];
                if (this.$store.getters.ZAYAVKIFILTERS) {
                    this.$store.getters.ZAYAVKIFILTERS.orglist.forEach((item) => {
                        if (item.ID != 16) {
                            ret.push({text: item.Name + ' (' + item.InnTsj + ')', value: item.ID});
                        }
                    });
                }
                return ret;
            },
            orglist() {
                let ret = [];
                if (this.$store.getters.ZAYAVKIFILTERS) {
                  if(localStorage.getItem('idtsg')>0){
                    this.$store.getters.ZAYAVKIFILTERS.orglist.forEach((item) => {
                      if(item.ID == localStorage.getItem('idtsg'))
                        ret.push({text: item.Name+ ' (' + item.InnTsj + ')', value: item.ID});
                    });
                  }else{
                    this.$store.getters.ZAYAVKIFILTERS.orglist.forEach((item) => {
                        ret.push({text: item.Name+ ' (' + item.InnTsj + ')', value: item.ID});
                    });
                  }
                }
                return ret;
            },
            houseslist() {
                let ret = [];
                const IdOrg = this.IdOrg ? this.IdOrg.value : 0;
                const IdClient = this.IdClient ? this.IdClient.value : 0;
                if (this.$store.getters.ZAYAVKIFILTERS) {
                    this.$store.getters.ZAYAVKIFILTERS.houselist.forEach((item) => {
                        if (item.IdTsj == IdOrg || item.IdTsj == IdClient) {
                            let exits = false;
                            for (let h of this.houses) {
                                if (h.ID == item.ID) {
                                    exits = true;
                                    break;
                                }
                            }
                            if (!exits) {
                                ret.push({Name: item.Name, ID: item.ID});
                            }
                        }
                    });
                }
                return ret;
            },
            objectList() {
              let ret = [];
              const IdOrg = this.IdOrg ? this.IdOrg.value : 0;
              const IdClient = this.IdClient ? this.IdClient.value : 0;
              if (this.$store.getters.ZAYAVKIFILTERS) {
                this.$store.getters.ZAYAVKIFILTERS.houselist.forEach((item) => {
                  if (item.IdTsj == IdOrg || item.IdTsj == IdClient) {
                      ret.push({text: item.Name, value: item.ID});
                  }
                });
              }
              return ret;
            },
            summaRules() {
                const rules = [];
                let rule = v => !!v || 'Введите сумму';
                rules.push(rule);
                rule = v => (v && v.length <= 10) || 'Сумма не более 10 символов';
                rules.push(rule);
                if (this.UseSummLimit) {
                    /*rule = v => (v && this.fromCurrency(v) <= limitsum) || 'Сумма превышает лимит';
                    rules.push(rule);*/
                }
                return rules;
            },
            fileRules() {
                const rules = [];
                let rule = v => {
                    if (v) {
                        return v.size < 1024 * 1024 || 'Превышен размер файла';
                    }
                    return !v || 'Превышен размер файла';
                };
                rules.push(rule);
                return rules;
            },
            orgRules() {
              const rules = [];
              let rule = v => !!v || 'Выберите плательщика';
              rules.push(rule);

              return rules;
            },

        },
        watch: {
            date () {
                this.PlanDate = this.formatDate(this.date);
            }
        },
        methods: {
            numberRule: v  => {
              /*if (!v.trim()) return true;*/
              if (!isNaN(parseFloat(v)) && v >= 0 && v <= 100) return true;
              return 'Введите процент от 0 до 100';
            },
            formatDate (date) {
                if (!date) return null;

                const [year, month, day] = date.split('-');
                return `${day}.${month}.${year}`;
            },
            parseDate (date) {
                if (!date) return null;
                const [day, month, year] = date.split('.');
                return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
            },
            formatCurrency(value) {
                let formatter = new Intl.NumberFormat('ru-RU', {maximumFractionDigits: 2});
                return formatter.format(value/1);
            },
            fromCurrency(value) {
                if (!value) return 0;
                value = value.replace(/\s/, '');
                value = value.replace(/,/, '.');
                return parseFloat(value);
            },
            houseAllow(statii) {
                let aval = false;
                if (statii && statii.Houses) {
                    for (let sh of statii.Houses) {
                        for (let h of this.houses) {
                            if (sh.IdHouse == h.ID) {
                                aval = true;
                                break;
                            }
                        }
                        if (aval) break;
                    }
                }

                if (!aval && statii.sub) {
                    for (let subst of statii.sub) {
                      if (subst.Houses){
                          for (let sh of subst.Houses) {
                            for (let h of this.houses) {
                                if (sh.IdHouse == h.ID) {
                                    aval = true;
                                    break;
                                }
                            }
                            if (aval) break;
                          }
                      }
                      if (aval) break;
                    }
                }
                return aval;
            },
            loadData() {
              if (!this.$props.id > 0) {
                this.localnewZayav = JSON.parse(localStorage.getItem(this.$props.newZayav));
                if(this.localnewZayav){
                  if (this.localnewZayav['IdOrg']) {
                    this.IdOrg = this.localnewZayav['IdOrg'];
                  }
                }
              }
                this.$store.dispatch('GET_ZAYAVKIFILETRS', {IdOrg: this.IdOrg ? this.IdOrg.value : 0, Date: this.date}).then(() => {
                    this.file = null;
                    if (this.$props.id > 0) {
                        this.$store.dispatch('EDIT_ZAYAVKILIST', {id: this.$props.id})
                            .then(response => {
                                for (let item of this.orglist) {
                                    if (item.value == response.data.IdSender) {
                                        if(!this.IdOrg){
                                            this.IdOrg = item;
                                            this.loadData();
                                        }
                                        this.IdOrg = item;
                                        break;
                                    }
                                }
                                for (let item of this.kontragentlist) {
                                    if (item.value == response.data.IdReceiver) {
                                        this.IdReceiver = item;
                                        break;
                                    }
                                }
                                for (let item of this.orglist) {
                                    if (item.value == response.data.IdClient) {
                                        this.IdClient = item;
                                        break;
                                    }
                                }
                              let houses = [];
                              Object.entries(response.data.houses).forEach(([key, h]) => {
                                houses.push({ID: h.IdHouse, Name: h.Name, Summ: this.formatCurrency(h.Summ), IdStatii: h.IdStatiObject, key: key, percentProfit: h.percentProfit});
                              });
                              this.houses = houses;
                              houses = [];
                              Object.entries(response.data.houses).forEach(([key, h]) => {
                                //let houses2level = [];
                                for (let item of this.staiilist) {
                                  if (item.value === h.IdStatiObject) {
                                    h.IdStatiObject = item;
                                    break;
                                  }
                                }
                                for (let s of h.Statii) {

                                  for (let item of this.staiilist) {
                                    if (item.value === s.IdStatiObject) {
                                      s.IdStatiObject = item;
                                      break;
                                    }
                                  }
                                  houses.push({ID: h.IdHouse, Name: h.Name, Summ: this.formatCurrency(h.Summ), IdStatii: h.IdStatiObject, Statii: [{ ID: s.IdHouse, Summ: this.formatCurrency(s.Summ), SummPlan: '', IdStatii: s.IdStatiObject.value, Volume: s.Volume, percentProfit: s.percentProfit}], key: key, percentProfit: h.percentProfit});
                                }
                              });

                              this.houses = houses;
                                for (let item of this.staiilist) {
                                    if (item.value === response.data.IdStatiObject) {
                                        this.IdStatii = item;
                                        break;
                                    }
                                }
                                this.StateZayv = response.data.StateZayv;
                                if(this.houses.length > 0) {
                                    this.Summa = this.formatCurrency(response.data.Summa);
                                }else{
                                    this.SummaNoObject = this.formatCurrency(response.data.Summa);
                                }
                                this.date = response.data.PlanDate;
                                this.CommentRefuse = response.data.CommentRefuse;
                                this.Osnovanie = response.data.Osnovanie;
                                this.fileexist = response.fileexist;
                                this.filelink = response.filelink;
                                this.TypeOrder = this.getTypeOrder(response.data.TypeOrder);
                                this.filescoreexist = response.filescoreexist;
                                this.filescorelink = response.filescorelink;
                                this.loading = false;
                            });

                    } else {
                        /*this.$refs.form.reset();*/
                        this.IdStatii = '';
                        this.IdReceiver = '';
                        this.houses = [];

                        this.localnewZayav = JSON.parse(localStorage.getItem(this.$props.newZayav));

                        if(!this.localnewZayav){
                            this.localnewZayav={};
                            localStorage.setItem(this.$props.newZayav, JSON.stringify(this.localnewZayav));
                        }else {
                            this.IdClient = this.localnewZayav['IdClient'];
                            if (this.localnewZayav['IdOrg']) {
                                this.IdOrg = this.localnewZayav['IdOrg'];
                            }
                            this.IdReceiver = this.localnewZayav['IdReceiver'];
                            this.TypeOrder = this.localnewZayav['TypeOrder'];
                            this.Osnovanie = this.localnewZayav['Osnovanie'];
                            this.Summa = this.localnewZayav['Summa'];
                            if(this.localnewZayav['PlanDate']){
                              this.PlanDate = this.localnewZayav['PlanDate'];
                            }else{
                                let date = new Date();
                                let month = date.getMonth()+1;
                                if (month < 10) {
                                  month = "0" + month;
                                }
                                let day = date.getDate();
                                if (day < 10) {
                                  day = "0" + day;
                                }
                                this.PlanDate = day+'.'+month+'.'+date.getFullYear();
                            }
                            this.IdStatii = this.localnewZayav['IdStatii'];
                            this.SummaNoObject = this.localnewZayav['SummaNoObject'];
                            if(this.localnewZayav['houses']){
                                this.houses = this.localnewZayav['houses'];
                            }
                        }

                        this.loading = false;
                    }
                });
            },
            changeReceiver() {
                if (this.IdReceiver && this.$props.id == 0) {
                    this.localnewZayav['IdReceiver'] = this.IdReceiver;
                    localStorage.setItem(this.$props.newZayav, JSON.stringify(this.localnewZayav));
                }
            },
            changeOrgClient() {
                if(this.IdClient && this.$props.id == 0) {
                    this.localnewZayav['IdClient'] = this.IdClient;
                    localStorage.setItem(this.$props.newZayav, JSON.stringify(this.localnewZayav));
                }
            },
            changeOrg() {
                if(this.IdOrg) {
                  if(this.$props.id == 0) {
                    this.localnewZayav['IdOrg'] = this.IdOrg;
                    localStorage.setItem(this.$props.newZayav, JSON.stringify(this.localnewZayav));
                  }
                }else{
                    this.IdOrg={value:0};
                }
                this.loading = true;
                this.$store.dispatch('GET_ZAYAVKIFILETRS', {IdOrg: this.IdOrg ? this.IdOrg.value : 0, Date: this.date}).then(() => {
                    this.IdStatii = '';
                    //this.IdReceiver = '';

                    this.houses = [];
                    this.loading = false;
                });
            },
            changeDate() {
                if(this.date && this.$props.id == 0) {
                    let date = new Date(this.date);
                    let month = date.getMonth()+1;

                    if (month < 10) {
                        month = "0" + month;
                    }
                    let day = date.getDate();
                    if (day < 10) {
                        day = "0" + day;
                    }
                    this.localnewZayav['PlanDate'] = day+'.'+month+'.'+date.getFullYear();
                    localStorage.setItem(this.$props.newZayav, JSON.stringify(this.localnewZayav));
                }
            },

            changePlanDate() {
                if(this.PlanDate && this.$props.id == 0) {
                    this.localnewZayav['PlanDate'] = this.PlanDate;
                    localStorage.setItem(this.$props.newZayav, JSON.stringify(this.localnewZayav));
                }
            },
            changeOsnovanie() {
                if(this.Osnovanie && this.$props.id == 0) {
                    this.localnewZayav['Osnovanie'] = this.Osnovanie;
                    localStorage.setItem(this.$props.newZayav, JSON.stringify(this.localnewZayav));
                }
            },
            changeTypeOrder() {
                if(this.TypeOrder && this.$props.id == 0) {
                    this.localnewZayav['TypeOrder'] = this.TypeOrder;
                    localStorage.setItem(this.$props.newZayav, JSON.stringify(this.localnewZayav));
                }
            },
            limitsumhouse(id) {
                let Summ = 0;
                if (this.IdStatii && this.IdStatii.houses) {
                    for (let h of this.IdStatii.houses) {
                        if (h.IdHouse == id) {
                            if (h.Summ) {
                                Summ = h.Summ;
                            }
                            if (!this.id && h.SummUsed) {
                                Summ -= parseFloat(h.SummUsed);
                            }
                            break;
                        }
                    }
                }
                return Summ;
            },
            UseSumLimitHouse(id) {
                let ret = false;
                if (this.IdStatii && this.IdStatii.houses) {
                    for (let h of this.IdStatii.houses) {
                        if (h.IdHouse == id) {
                            ret = h.UseLimit == 1 ? true : false;
                            break;
                        }
                    }
                }
                return ret;
            },
            isVolume(id) {
                let ret;
                ret = false;
                if(id) {
                    if (id.isVolume > 0) {
                        ret = true;
                    } else {
                        ret = false;
                    }
                }
                return ret;
            },
            summaRulesHouse(id) {

                const rules = [];
                let rule = v => !!v || 'Введите сумму';
                rules.push(rule);
                rule = v => (v && v.length <= 10) || 'Сумма не более 10 символов';
                rules.push(rule);
                /*Лимиты раскоментить */
                if (this.UseSumLimitHouse(id)) {
                    //rule = v => (this.fromCurrency(v) > 0 && this.fromCurrency(v) <= limitsum) || 'Сумма превышает лимит';
                    //rules.push(rule);
                }
                return rules;
            },
            summaValid() {
                this.syncSums();
                let statiiActive = false;
                if(!this.IdStatii==''){
                  statiiActive = true;
                }
                for (let house of this.houses) {
                  for (let h of house.Statii) {
                    if (h.IdStatii && !statiiActive)
                      statiiActive = true;
                  }
                }
                for (let house of this.houses) {
                  for (let h of house.Statii) {
                    if (!h.IdStatii)
                      statiiActive = false;
                  }
                }
                if(!this.IdStatii==''){
                    statiiActive = true;
                }
                let Summa = 0;
                if(this.SummaNoObject>0){
                    Summa = this.SummaNoObject;
                }else{
                    Summa = this.Summa;
                }

                if (!statiiActive || !this.IdOrg || !this.IdReceiver ||
                    this.PlanDate === '' || this.PlanDate === undefined ||
                    this.fromCurrency(Summa) <= 0 ||
                    (this.limitsum > 0 && Number(Summa) > this.limitsum)
                ) {
                    return false;
                }
                return true;
            },
            changeSummaNoObject() {
                if(this.SummaNoObject && this.$props.id == 0) {
                    this.localnewZayav['SummaNoObject'] = this.SummaNoObject;
                    localStorage.setItem(this.$props.newZayav, JSON.stringify(this.localnewZayav));
                }
            },
            changeSumma() {
                if(this.Summa && this.$props.id == 0) {
                    this.localnewZayav['Summa'] = this.Summa;
                    localStorage.setItem(this.$props.newZayav, JSON.stringify(this.localnewZayav));
                }
            },
            changeVolume() {
                if(this.houses.length > 0 && this.$props.id == 0) {
                    this.localnewZayav['houses'] = this.houses;
                    localStorage.setItem(this.$props.newZayav, JSON.stringify(this.localnewZayav));
                }
            },
            changeStatii(houseStatii, index, i) {
                //this.houses = [];
                if (!this.houses.length > 0) {
                    if (this.IdStatii && this.$props.id == 0) {
                        this.localnewZayav['IdStatii'] = this.IdStatii;
                        localStorage.setItem(this.$props.newZayav, JSON.stringify(this.localnewZayav));
                    }
                }else if(this.$props.id == 0){
                    this.localnewZayav['houses'] = this.houses;
                    localStorage.setItem(this.$props.newZayav, JSON.stringify(this.localnewZayav));
                }
                this.syncSums();
              if(index>=0) {
                if (this.houses[index]['Statii'][i]['IdStatii'] !== null) {
                  this.houses[index]['Statii'][i]['percentProfit'] = this.houses[index]['Statii'][i]['IdStatii']['percentProfit'];
                }
              }else{
                //this.percent = houseStatii.percentProfit;
              }
            },
            addObject(id, Name) {
                this.houses.push({ID: id, Name: Name, Summ: 0, Statii: [{ID: id, Name: Name, Summ: 0, IdStatii:''}]});
                this.IdStatii=null;
                if(this.$props.id == 0) {
                  this.localnewZayav['houses'] = this.houses;
                  localStorage.setItem(this.$props.newZayav, JSON.stringify(this.localnewZayav));
                }
                this.syncSums();
            },
            delObject(id) {
              this.houses = this.houses.filter(function (item) {
                return item.ID !== id;
              });
              if (this.$props.id == 0){
                this.localnewZayav['houses'] = this.houses;
                localStorage.setItem(this.$props.newZayav, JSON.stringify(this.localnewZayav));
              }
              this.syncSums();
            },
            delObjectStatii(indexHouse, indexObject) {
              this.houses[indexHouse].Statii.splice(indexObject, 1);
              if (this.$props.id == 0) {
                this.localnewZayav['houses'] = this.houses;
                localStorage.setItem(this.$props.newZayav, JSON.stringify(this.localnewZayav));
              }
            },
            delObjectIndex(index){
              this.houses.splice(index, 1);
              if (this.$props.id == 0){
                this.localnewZayav['houses'] = this.houses;
                localStorage.setItem(this.$props.newZayav, JSON.stringify(this.localnewZayav));
              }
              this.syncSums();
            },
            delFile(type){
              if(type == 'file'){
                this.filelink=null;
                this.fileDelete = true;
              }
              if(type == 'filescore') {
                this.filescorelink = null;
                this.filescoreDelete = true;
              }
            },
            addHouseIdStatii(id, Name, index) {
              this.houses[index].Statii.push({ID: id, Name: Name, Summ: 0, IdStatii: ''});
              if (this.$props.id == 0){
                this.localnewZayav['houses'] = this.houses;
                localStorage.setItem(this.$props.newZayav, JSON.stringify(this.localnewZayav));
              }
            },
            syncSums() {
              let Summa = 0.00;
              for (let house of this.houses) {
                for (let Statii of house.Statii) {
                  Summa += this.fromCurrency(Statii.Summ);
                }
              }
              if (Summa == 0 && this.Summa > 0) {
                Summa = this.Summa;
                if(this.$props.id == 0){
                  this.localnewZayav['Summa'] = this.Summa;
                  localStorage.setItem(this.$props.newZayav, JSON.stringify(this.localnewZayav));
                }
              }
              this.Summa = this.formatCurrency(Summa);
            },
            saveZayavka() {

                let res;
                if(this.houses.length <= 0) {
                    this.Summa = this.SummaNoObject;
                }
                if (!this.$refs.form.validate() ||
                     !this.IdOrg || !this.IdReceiver ||
                    this.PlanDate === '' || this.PlanDate === undefined ||
                    this.fromCurrency(this.Summa) <= 0 ||
                    (this.limitsum > 0 && Number(this.Summa) > this.limitsum)
                ) {
                    this.resulttext = 'Заполните форму заявки!';
                    this.snackbarresult = true;
                    return;
                }
                let IdStatii = 0;
                if(!this.IdStatii === undefined)
                  IdStatii = this.IdStatii.value;
                let houses = [];
                for (let h of this.houses ) {
                  let houses2level = [];
                  for (let s of h.Statii) {
                    //if(!this.IdStatii)
                    IdStatii = s.IdStatii;
                    houses2level.push({ID: s.ID, Summ: this.fromCurrency(s.Summ), IdStatii: s.IdStatii, Volume: s.Volume, percentProfit: s.percentProfit});
                  }
                  houses.push({ID: h.ID, Summ: this.fromCurrency(h.Summ), Statii: houses2level});
                }
                if(!this.Osnovanie)
                    this.Osnovanie='';
              if(!this.CommentRefuse)
                this.CommentRefuse='';
                let IdClient = '';
                if(this.IdClient){
                    IdClient = this.IdClient.value;
                }else{
                    IdClient = '';
                }
                if(this.houses.length <= 0) {
                    this.Summa = this.SummaNoObject;
                }
                if(localStorage.getItem('idtsg')>0)
                  this.TypeOrder = 'Оплата контрагентам';

                const data = {
                    IdStatiObject: IdStatii,
                    Summa: this.fromCurrency(this.Summa),
                    PlanDate: this.PlanDate,
                    IdZayavitel: this.IdZayavitel,
                    IdSender: this.IdOrg.value,
                    IdReceiver: this.IdReceiver.value,
                    Osnovanie: this.Osnovanie,
                    TypeOrder: this.getTypeOrderId(this.TypeOrder),
                    IdClient: IdClient,
                    CommentRefuse: this.CommentRefuse,
                    houses: houses,
                    file: this.file,
                    filescore: this.filescore,
                    fileDelete: this.fileDelete,
                    filescoreDelete: this.filescoreDelete,
                    percent: this.percent,
                };

                if (this.$props.id > 0) {
                    data['ID'] = this.id;
                    res = this.$store.dispatch('UPDATE_ZAYAVKILIST', data);
                } else {
                    res = this.$store.dispatch('SAVE_ZAYAVKILIST', data);
                    localStorage.setItem(this.$props.newZayav, JSON.stringify([]));
                }
                res.then(response => {
                    if (response.status === 1) {
                        this.$parent.closeTab(this.$vnode.key, 'tabZaiavki0');
                        bus.$emit('resetFilterhTabZaiavki', {IdOrg: this.IdOrg.value});
                    } else {
                        this.resulttext = response.message;
                        this.snackbarresult = true;
                    }
                });

            },
            saveStatus(state) {
                const data = {
                    id: this.id,
                    StateZayv: state,
                    CommentRefuse: this.CommentRefuse
                };
                this.$store.dispatch('UPDATESTATE_ZAYAVKILIST', data).then(response => {
                    if (response.status === 1) {
                        this.StateZayv = state;
                        bus.$emit('resetFilterhTabZaiavki', {IdOrg: this.IdOrg.value});
                    } else {
                        this.resulttext = response.message;
                        this.snackbarresult = true;
                    }
                });
            },
            copyZayavka(){
              let newZayavkaAdd = [];
              let newZayavkaAddId,lastnewZayavkaAdd;
              newZayavkaAdd = JSON.parse(localStorage.getItem("newZayavkaAdd"));
              if(newZayavkaAdd) {
                lastnewZayavkaAdd = newZayavkaAdd[newZayavkaAdd.length - 1];
              }
              if(newZayavkaAdd){
                if(newZayavkaAdd.length>0) {
                  newZayavkaAddId = lastnewZayavkaAdd+1;
                }else{
                  newZayavkaAddId = 1;
                }
              }else{
                newZayavkaAdd = [];
                newZayavkaAddId = 1;
              }
              newZayavkaAdd.push(newZayavkaAddId);
              localStorage.setItem('newZayavkaAdd', JSON.stringify(newZayavkaAdd));

              let localnewZayav = {};
              if(this.IdClient)
                localnewZayav['IdClient'] = this.IdClient;
              if(this.IdOrg)
                localnewZayav['IdOrg'] = this.IdOrg;
              if(this.IdReceiver)
                localnewZayav['IdReceiver'] = this.IdReceiver;
              if(this.TypeOrder)
                localnewZayav['TypeOrder'] = this.TypeOrder;
              if(this.Osnovanie)
                localnewZayav['Osnovanie'] = this.Osnovanie;
              if(this.Summa)
                localnewZayav['Summa'] = this.Summa;
              if(this.PlanDate)
               localnewZayav['PlanDate'] = this.PlanDate;
              if(this.IdStatii)
                localnewZayav['IdStatii'] = this.IdStatii;
              if(this.SummaNoObject)
                localnewZayav['SummaNoObject'] = this.SummaNoObject;
              if(this.houses){
                localnewZayav['houses'] = this.houses;
              }

              let newZayav = 'newZayav' + newZayavkaAddId;
              localStorage.setItem(newZayav, JSON.stringify(localnewZayav));
              this.$parent.addTab('Добавить заявку', newZayav, 'ZayavkiAdd', {id: 0, IdOrgDef: this.IdOrg, newZayav: newZayav});

            },
            refreshHandler() {
                this.loadData();
            },
            addHouse() {
             if(!this.houseslist.length > 0)
               this.addHouseDialog = true;
            },
            getTypeOrder(TypeOrder) {
                switch (parseInt(TypeOrder)) {
                    case 1:
                        return 'Оплата контрагентам';
                    case 9:
                        return 'Оплата услуг сервиса';
                    case 11:
                        return 'Судебные расходы';
                    case 15:
                        return 'Перечисление на счет клиента';
                }
                return 'Оплата контрагентам';
            },
            getTypeOrderId(TypeOrder) {
                switch (TypeOrder) {
                    case 'Оплата контрагентам':
                        return 1;
                    case 'Оплата услуг сервиса':
                        return 9;
                    case 'Судебные расходы':
                        return 11;
                    case 'Перечисление на счет клиента':
                        return 15;
                }
                return 1;
            },

            addHousesVal(){
              this.housesVal = [];
              for (let object of this.objectList ) {
                this.housesVal.push(object.value);
              }
            },
            removeHousesVal(){
              this.housesVal = [];
            },
            addAllObject(){
              let percentProfit,isVolume = 0;
              for (let staii of this.staiiAllList ) {
                if(staii.value == this.staiiVal){
                  percentProfit = staii.percentProfit;
                  isVolume = staii.isVolume;
                }
              }
              for (let id of this.housesVal ) {
                for (let object of this.objectList ) {
                  if(object.value == id){
                    this.houses.push({
                      ID: id,
                      Name: object.text,
                      Summ: 0,
                      Statii: [{ID: id, Name: object.text, Summ: 0, SummPlan: '', IdStatii: this.staiiVal, percentProfit: percentProfit, isVolume: isVolume, Volume:''}]
                    });
                  }
                }
              }
              this.housesUnique();
              this.IdStatii=null;
              if(this.$props.id == 0) {
                this.localnewZayav['houses'] = this.houses;
                localStorage.setItem(this.$props.newZayav, JSON.stringify(this.localnewZayav));
              }
              this.syncSums();
            },
            housesUnique(){
              let unique = [];
              this.houses.forEach((item,index) => {
                if(item.Statii[0].IdStatii>0){
                  for (let un of unique ) {
                    if(un.ID==item.ID && un.IdStatii==item.Statii[0].IdStatii){
                      this.houses.splice(index, 1);
                    }
                  }
                  unique.push({ID:item.ID, IdStatii:item.Statii[0].IdStatii});
                }
              });

              this.houses.forEach((item) => {
                this.$store.dispatch('PLAN_STATII_ZAYAVKA', {IdOrg: this.IdOrg.value, IdStatii: item.Statii[0].IdStatii, IdHouse: item.ID, PlanDate: this.PlanDate})
                    .then(response => {
                      item.Statii[0].SummPlan = response.data;
                    });
              });
            },
            summaPlan(item){
              return item.SummPlan-item.Summ;
            },
            SummAllDistSquare(){
              let numbObject = [];
              for (let house of this.houses ) {
                numbObject.push(house.ID);
              }
              numbObject = numbObject.filter(function (e, i, arr) {
                return arr.lastIndexOf(e) === i;
              });
              this.$store.dispatch('SUMM_DIST_ZAYAVKA', {SummAllDist: this.SummAllDist, numbObject: numbObject})
                  .then(response => {
                    this.houses.forEach((item) => {
                      for (let data of response.data){
                        if(data.ID == item.ID)
                          item.Statii[0].Summ = String(data.summ.toFixed(2));
                      }
                    });
                  });
            },
            SummAllDistNumb(){
              let numbObject = [];
              for (let house of this.houses ) {
                numbObject.push(house.ID);
              }
              numbObject = numbObject.filter(function (e, i, arr) {
                return arr.lastIndexOf(e) === i;
              });
              let summ = (this.SummAllDist / numbObject.length).toFixed(2);
              if(summ>0){
                summ = String(summ);
                this.houses.forEach((item) => {
                  item.Statii[0].Summ = summ;
                });
              }
            },
            ppFile(){
              this.$store.dispatch('PP_ZAYAVKA', {ID: this.$props.id})
                  .then(response => {
                    if(response.status==1){
                      let el = document.createElement('a');
                      el.setAttribute('href', `data:text/plain;charset=utf-8,${encodeURIComponent(response.fileText)}`);
                      el.setAttribute('download', 'pp'+this.$props.id+'.txt');
                      el.style.display = 'none';
                      document.body.appendChild(el);
                      el.click();
                      document.body.removeChild(el);
                    }
                  });
            }
        },
        filters: {
            toCurrency: function (value) {
                if (value === undefined) value = 0;
                let formatter = new Intl.NumberFormat('ru-RU', {maximumFractionDigits: 2});
                return formatter.format(value/1);
            },
            toDate: function (value) {
                if (!value) return '';
                const [year, month, day] = value.split('-');
                return `${day}.${month}.${year}`;
            }
        }
    }
</script>

<style scoped>
    .tabcontent {
        padding-top: 45px;
    }
    .row.staiilist_item{
      display: block;
    }
    .RefuseClose{
      margin-right: 15px;
      margin-top: 20px;
      padding: 0px 0px 0px;
    }
    .staiilist_item{
        position: relative;
        padding-bottom: 20px;
    }
    .staiilist_item button{
        position: absolute;
        right: 0px;
        z-index: 1;
    }
</style>